import { ReactElement } from 'react'
import { StyledCategoryButton } from './styles'
import { Flex, SVG, SVGByName, Text } from '../..'
import { CategoryButtonProps } from './props'
import { ChevronRight } from '../../Assets/Icons'

const CategoryButton = ({
    icon,
    text,
    variant,
    ...props
}: CategoryButtonProps): ReactElement => {
    return (
        <StyledCategoryButton variant={variant} {...props}>
            <Flex
                alignItems="center"
                justifyContent="center"
                direction={variant === 'oneLineButton' ? 'row' : 'column'}
                gap={variant === 'oneLineButton' ? 16 : 8}
            >
                <SVGByName name={icon} />
                <Text bold primary>
                    {text}
                </Text>
            </Flex>
            {variant === 'oneLineButton' && <SVG src={ChevronRight} />}
        </StyledCategoryButton>
    )
}

export default CategoryButton

export { StyledCategoryButton }
